module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_garten_01.64e3bd4c.jpg";